import axios from "axios";

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API, withCredentials: true });

export const asset = (u) => (u && u.startsWith("/api") ? `${BACKEND_URL}${u}` : u);

export const getChildId = () => localStorage.getItem("zq_child");
export const setChildId = (id) => localStorage.setItem("zq_child", id);

export const STATUS_LABEL = {
  not_started: "Not Started",
  learning: "Learning",
  needs_practice: "Needs Practice",
  mastered: "Mastered",
};
